import React, { useEffect } from 'react';
import { MetaPixel } from './components/MetaPixel';
import { ChemistryOrbitFlow } from './components/ChemistryOrbitFlow';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { ProblemSolution } from './components/ProblemSolution';
import { SystemIntro } from './components/SystemIntro';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferStack } from './components/OfferStack';
import { MaterialPreview } from './components/MaterialPreview';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { HowItWorks } from './components/HowItWorks';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    document.title = 'Wizualna Chemia™ | Edycja 2026 — materiały dla nauczycieli chemii';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', '7 kompletnych tomów i 3 bonusy dla nauczycieli chemii: 568 stron gotowych do wydruku dla klas 7–8, liceum i technikum. Dostęp cyfrowy od razu.');
  }, []);
  return <div className="relative w-full bg-paper text-ink" data-id="element-0" data-mp="3dlns8ajhypvn">
      <MetaPixel data-id="element-1" data-mp="nvsup6ui4rx0" />
      <ChemistryOrbitFlow data-id="element-2" data-mp="nwc2vvuco1xu" />

      <div className="relative z-10" data-id="element-3" data-mp="nv0ypuwzss67">
        <TopBar data-id="element-4" data-mp="suncq6knacg2" />
        <main data-id="element-5" data-mp="su44xiopl4fr">
          <span id="hero-sentinel" aria-hidden="true" data-id="element-6" data-mp="stubfl4ggf5b" />
          <Hero data-id="element-7" data-mp="swglpsiqd8r8" />
          <TrustBar data-id="element-8" data-mp="36877lhgoowl" />
          <ProblemSolution data-id="element-9" data-mp="35ovimiemwr0" />
          <SystemIntro data-id="element-10" data-mp="34x4zq3nzp7l" />
          <VolumesSection data-id="element-11" data-mp="38b6yx8f1wei" />
          <BonusesSection data-id="element-12" data-mp="3udaw269tuj3n" />
          <OfferStack data-id="element-13" data-mp="3ubzsa6gdtbcj" />
          <MaterialPreview data-id="element-14" data-mp="3ucje3y95kjvu" />
          <AudienceSection data-id="element-15" data-mp="d4nuteha5g1c" />
          <Testimonials data-id="element-16" data-mp="d4xq9hl3gfef" />
          <HowItWorks data-id="element-17" data-mp="d45tw4joadn3" />
          <Guarantee data-id="element-18" data-mp="d2l6cyvrzuyq" />
          <ClosingBlock data-id="element-19" data-mp="85uivqhn5x3a" />
          <FAQ data-id="element-20" data-mp="86mf93j2byum" />
        </main>
        <Footer data-id="element-21" data-mp="86cmx9ajpflr" />
        <div className="h-[58px] md:hidden" aria-hidden="true" data-id="element-22" data-mp="83qgjcze5654" />
        <FloatingCTA data-id="element-23" data-mp="3gm65ruscn35z" />
      </div>
    </div>;
}